import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';

export default function() {
	$('.m-blog-snippets:not(.js-blog-snippets-done)').each(function() {
		const wrapper = $(this);

		const swiper = new Swiper(wrapper.find('.swiper')[0], {
			modules: [Navigation],
			loop: false,
			slidesPerView: 1.15,
        	spaceBetween: 16,
        	breakpoints: {
        	    // when window width is >= 380px
        	    380: {
        	        slidesPerView: 1.5
        	    },
        	    620: {
        	        slidesPerView: 2
        	    },
        	    960: {
        	        slidesPerView: 2.5
        	    },
        	    1420: {
        	        slidesPerView: 3.5
        	    }
        	},
			navigation: {
				nextEl: '.bx-next',
				prevEl: '.bx-prev',
			},
			autoHeight: true
		});

		// done
		wrapper.addClass('js-blog-snippets-done');
	});
}
